<template>
  <v-app :style="{ 'background-color': 'white' }" id="root">
    <div
      v-if="!this.$store.state.authenticated || forceChangePasswordStatus"
      class="login-container"
      id="login-container"
    >
      <v-alert
        v-if="this.$store.state.isExpired"
        dense
        border="left"
        type="warning"
      >
        Your session has <strong>expired</strong>
      </v-alert>
      <v-snackbar
        v-model="snackbar"
        timeout="6000"
        fixed
        top
        right
        :color="snackbarColor"
      >
        <v-icon dark>{{ snackbarIcon }}</v-icon>
        <span>&nbsp;{{ snackbarMessage }}</span>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <forgot-password
        v-if="
          this.$route.name == 'ForgotPassword' ||
          this.$route.name == 'ValidateForgotPassword'
        "
      />

      <change-password
        :forcelast="forceLastChangePasswordStatus"
        v-else-if="
          (this.$store.state.authenticated &&
            (this.$route.name == 'ChangePassword' ||
              forceChangePasswordStatus)) ||
          (this.$store.state.authenticated &&
            (this.$route.name == 'ChangePassword' ||
              forceLastChangePasswordStatus))
        "
      />
      <change-email v-else-if="$route.name === 'ChangeEmail'" />
      <set-password v-else-if="$route.name === 'SetPassword'" />
      <reactive-dormant v-else-if="$route.name === 'ReactiveDormant'" />
      <login-otp v-else-if="$route.name === 'LoginOTP'" />
      <login v-else />
      <div class="d-flex justify-center align-center mb-6">
        <div class="d-flex justify-center align-center mr-2">
          <v-img
            max-height="150"
            max-width="130"
            src="./assets/logo-lps-putih 1.png"
          />
        </div>
        <div class="d-flex flex-column justify-center align-left">
          <div
            class="pl-6 font-weight-light"
            style="
              color: white;
              font-size: 12px;
              font-family: 'Inter', sans-serif;
            "
          >
            BNI berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK).
          </div>
          <div
            class="pl-6 font-weight-light"
            style="
              color: white;
              font-size: 12px;
              font-family: 'Inter', sans-serif;
            "
          >
            BNI merupakan peserta penjaminan Lembaga Penjamin Simpanan (LPS).
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <v-navigation-drawer
        v-model="drawer"
        app
        dark
        class="d-print-none image-logo"
        style="width: 310px;"
      >
        <div
          style="
            width: 200px;
            height: 200px;
            background: white;
            position: fixed;
            left: -100px;
            top: -100px;
            border-radius: 80%;
            filter: blur(70px);
          "
        ></div>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title d-flex justify-center">
              <v-img
                src="./assets/logo-white.png"
                class="mt-8 mb-4 logo-bni"
                max-width="150"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list dense nav>
          <v-subheader class="pl-4">
            <v-chip
              x-small
              class="py-2"
              color="white"
              :style="{
                'font-size': '11px',
                padding: '10px',
                margin: '1px',
                color: '#217889',
              }"
            >
              {{ versionApp }}
            </v-chip>
          </v-subheader>
          <v-progress-linear
            v-if="isMenuLoading"
            :active="isMenuLoading"
            :indeterminate="isMenuLoading"
            color="red lighten-2"
            class="mb-2 mt-2"
          />
          <v-list-item-group color="orange">
            <sub-menu
              v-for="(item, i) in menus"
              :key="i"
              :item="item"
              :root="root"
            />
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app flat light class="d-print-none" :style="{ 'left': drawer ? '310px' : '0' }">
        <v-app-bar-nav-icon @click="drawer = !drawer" />

        <v-toolbar-title>
          {{ $route.meta.appBarTitle }}
        </v-toolbar-title>

        <v-spacer />
                
        <template>
          <button
            class="search-trigger mr-6"
            type="button"
            @click="$root.$emit('open-command-palette')"
            @keydown.enter="$root.$emit('open-command-palette')"
            @keydown.space.prevent="$root.$emit('open-command-palette')"
          >
            <v-icon class="mr-2">mdi-magnify</v-icon>
            <span class="search-text font-weight-medium mr-2">Search...</span>
            <div class="shortcut-key">{{ isMac ? '⌘ + K' : 'Ctrl + K' }}</div>
          </button>
          <CommandPalette />
        </template>

        <v-menu
          offset-y
          rounded="lg"
          transition="slide-y-transition"
          :disabled="notifications && notifications.length > 0 ? false : true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              size="30"
              :color="
                notifications && notifications.length > 0 ? 'orange' : 'grey'
              "
              v-on="on"
              v-bind="attrs"
              class="mr-2"
            >
              <v-icon dark size="20"> mdi-bell </v-icon>
            </v-avatar>
          </template>
          <v-list two-line v-if="notifications && notifications.length > 0">
            <v-list-item
              class="align-center"
              v-for="(item, index) in notifications"
              :key="index"
              ripple
              link
              :to="item.link"
            >
              <v-avatar size="28" color="primary" class="mr-4">
                <v-icon color="white">mdi-star-outline</v-icon>
              </v-avatar>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ item.type }} : Date • {{ item.datetime }}
                </v-list-item-subtitle>
                <v-list-item-title>{{ item.description }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y rounded="lg" transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex flex-row align-center"
              :style="{ cursor: 'pointer' }"
              v-bind="attrs"
              v-on="on"
            >
              <v-avatar size="30" :style="{ 'background-color': '#717171' }">
                <v-icon dark size="20"> mdi-account </v-icon>
              </v-avatar>
              <v-toolbar-title :style="{ 'font-size': '13px' }" class="mx-1">
                Hallo {{ user == null ? '' : user.username }}, Selamat datang !
              </v-toolbar-title>
              <v-icon light size="20">mdi-menu-down</v-icon>
            </div>
          </template>
          <v-list dense>
            <v-list-item link to="/profile">
              <v-list-item-icon>
                <v-icon>mdi-account-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Profile</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/password-change">
              <v-list-item-icon>
                <v-icon>mdi-key</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleLogout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-main :style="{ 'margin-left': drawer ? '50px' : '0' }">
        <v-overlay :value="logoutLoading">
          <v-progress-circular indeterminate size="44" />
        </v-overlay>
        <v-snackbar
          v-model="snackbar"
          timeout="3000"
          fixed
          top
          right
          :color="snackbarColor"
        >
          <v-icon dark>{{ snackbarIcon }}</v-icon>
          <span>&nbsp;{{ snackbarMessage }}</span>
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <div
          id="breadcrumb-container"
          class="pa-0 ml-4 mr-2"
          v-if="breadcrumbs.length > 0"
        >
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
        <router-view
          :style="{
            'border-radius': '0',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            'background-color': 'white',
            'border-width': '0',
          }"
          id="view-container"
        />
      </v-main>

      <v-expand-transition>
        <v-card
          v-show="absoluteBar"
          :style="barStyle"
          class="mx-auto pl-5 pr-5 pt-2 pb-2"
          :width="minimized ? '120px' : '350px'"
          elevation="9"
          @dragend="dropBar"
          draggable="true"
        >
          <v-card-text class="d-flex flex-row">
            <v-row style="width: 80%" class="justify-space-between">
              <h4 v-if="!minimized">{{ absoluteBarText }}</h4>
              <div style="align-items: ">
                <v-icon @click="minimized = true"> mdi-window-minimize </v-icon>
                <v-icon @click="minimized = false">
                  mdi-window-maximize
                </v-icon>
                <v-icon @click="absoluteBar = !absoluteBar">
                  mdi-close-circle
                </v-icon>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-expand-transition>
      <notif-user
        style="display: none"
        :getNotif="forceLastExpired"
        :userName="userLogin"
        :expiredDate="dateExpired"
      />
    </div>
  </v-app>
</template>

<script>
import decryptUserData from '@utils/decryptUserData';
import { date, showAlert } from './lib/helpers';
import { setupZohoChat } from './plugins/zohoChat';

export default {
  name: 'App',
  components: {
    Login: () => import('./components/Login.vue'),
    ForgotPassword: () => import('./components/ForgotPassword.vue'),
    ChangePassword: () => import('./components/ChangePassword.vue'),
    ChangeEmail: () => import('./components/ChangeEmail.vue'),
    SetPassword: () => import('./components/SetPassword.vue'),
    ReactiveDormant: () => import('./components/ReactiveDormant.vue'),
    SubMenu: () => import('./components/SubMenu.vue'),
    NotifUser: () => import('./components/NotifUser.vue'),
    LoginOtp: () => import('./views/login-otp/LoginOtp.vue'),
    CommandPalette: () => import('./components/@drontVue/components/CommandPalette'),
    
  },

  beforeMount() {
    if (this.$store.state.authenticated && this.menus.length == 0) {
      const userData = JSON.parse(localStorage.getItem('logged_in_qram'))?.user;
      const decryptedUserData = decryptUserData(userData);
    
      if (decryptedUserData && !decryptedUserData.force_password_change && decryptedUserData.force_last_change_password === 0) {
        this.$store.dispatch('renderMenu');
      }
    }
  },
  mounted() {
    try {
      // eslint-disable-next-line no-restricted-globals
      if (top.location.hostname != self.location.hostname) {
        throw new Error('404 - Not Found');
      }
    } catch (e) {
      document.querySelector('#html-root').remove();
    }
    this.isMac = (() => {
      if (navigator.userAgentData?.platform) {
        return navigator.userAgentData.platform.toLowerCase().includes('mac');
      }

      return navigator.platform?.toLowerCase().includes('mac');
    })();

    if (localStorage.getItem('logged_in_qram') != null) {
      if (
        JSON.parse(localStorage.getItem('logged_in_qram')).user == null ||
        JSON.parse(localStorage.getItem('logged_in_qram')).token == null
      ) {
        this.$store.dispatch('logout', null, { root: true });
      } else {
        const userData = JSON.parse(localStorage.getItem('logged_in_qram'))?.user;
        const decryptedUserData = decryptUserData(userData);
        
        if (decryptedUserData && !decryptedUserData.force_password_change && decryptedUserData.force_last_change_password === 0) {
          this.checkNotif();
          if (this.$store.state.user) {
            setupZohoChat(this.$store.state.user);
          }
        }
        
        this.$store.commit(
          'setUser',
          decryptedUserData,
          { root: true }
        );
      }
    }
  },
  computed: {
    forceChangePasswordStatus() {
      if (this.$store.state.user == null) {
        return false;
      }
      return this.$store.state.user.force_password_change === true;
    },

    forceLastChangePasswordStatus() {
      if (this.$store.state.user == null) {
        return false;
      }
      return this.$store.state.user.force_last_change_password === 1;
    },

    forceLastExpired() {
      const forceLastExpired =
        this.$store.state?.user != null &&
        this.$store.state.user.expired_notification;
      return forceLastExpired;
    },

    userLogin() {
      return this.$store.state.user.fullname;
    },

    dateExpired() {
      return this.$store.state.user.expired_date_format;
    },

    menus() {
      if (this.versionApp == null) {
        const userData = JSON.parse(localStorage.getItem('logged_in_qram'))?.user;
        const decryptedUserData = decryptUserData(userData);
        
        if (decryptedUserData && !decryptedUserData.force_password_change && decryptedUserData.force_last_change_password === 0) {
          this.getVersionApp();
        }
      }
      return this.$store.state.menus;
    },
    isMenuLoading() {
      return this.$store.state.isMenuLoading;
    },

    logoutLoading() {
      return this.$store.state.logoutLoading;
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(val) {
        showAlert(this.$store, '', '', '', val);
      },
    },
    snackbarColor() {
      return this.$store.state.snackbarColor;
    },
    snackbarMessage() {
      return this.$store.state.snackbarMessage;
    },
    snackbarIcon() {
      return this.$store.state.snackbarIcon;
    },
    absoluteBar: {
      get() {
        return this.$store.state.absoluteBar;
      },
      set(val) {
        this.$store.commit('setInsertProgressGlobal', {
          absoluteBar: val,
          absoluteBarText: '',
        });
      },
    },
    absoluteBarText() {
      return this.$store.state.absoluteBarText;
    },
    minimized: {
      get() {
        return this.$store.state.minimized;
      },
      set(val) {
        this.$store.commit('setMinimized', val);
      },
    },
    user() {
      return this.$store.state.user;
    },
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
    notifications() {
      return this.$store.state.notifications;
    },
  },
  data() {
    return {
      intervalId: null,
      root: true,
      drawer: null,
      right: null,
      rightPos: 0,
      barStyle: {
        'z-index': '5',
        position: 'fixed',
        bottom: 0,
        right: 0,
        cursor: 'pointer',
      },
      versionApp: null,
      forcelast: null,
      isMac: false,
    };
  },

  created() {
    this.intervalId = setInterval(this.checkNotif, 3600000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    async handleLogout() {
      await this.$store.dispatch('logout');
      this.$router.replace({ name: 'Login' });
    },
    checkNotif() {
      this.$store.dispatch('getNotif', { date });
    },
    dropBar(x) {
      this.barStyle.right = `${
        document.getElementById('view-container').offsetWidth - x.screenX
      }px`;
    },

    getVersionApp() {
      this.$store.dispatch('getVersion', { date }).then((version) => {
        this.versionApp = version;
      });
    },
  },
};
</script>
<style>
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 12px;
}
.v-list--nav .v-list-item {
  padding: 0px 16px;
}
.v-list--nav {
  padding-left: 0;
  padding-right: 0;
}
.v-item-group .v-list-item--active {
  background-color: #f15a22 !important;
  color: white;
  border-radius: 0;
}
.image-logo .theme--dark.v-list-item--active:hover::before,
.image-logo .theme--dark.v-list-item--active::before {
  opacity: 0;
}
.image-logo {
  background-image: url('./assets/bottom-left-logo.svg'),
    linear-gradient(
      176deg,
      rgb(33, 120, 137) 1.67%,
      rgb(0, 94, 106) 86.88%,
      rgb(0, 94, 106) 86.88%
    );
  background-position: bottom left, 0% 0%;
  background-size: 480px auto, cover;
}
.v-breadcrumbs {
  padding: 0 10px 0 10px;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: #fff;
}
.login-container {
  background: url(./assets/login-bg.svg) center center no-repeat;
  background-size: cover;
  background-blend-mode: multiply;
  flex: 1 1 auto;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
  overflow-y: hidden !important;
}
#breadcrumb-container {
  border: #e1e0e0;
  border-width: thin;
  border-right: none;
  border-left: none;
  margin: 0px 20px 0px 20px !important;
}

nav ::-webkit-scrollbar {
  border: 1px solid #398593 !important;
}

/* Track */
nav ::-webkit-scrollbar-track {
  background: #398593 !important;
}

/* Handle */
nav ::-webkit-scrollbar-thumb {
  background: #005e6a !important;
}

/* Handle on hover */
nav ::-webkit-scrollbar-thumb:hover {
  background: #003c44 !important;
}
</style>
<style scoped>
.search-trigger {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  padding: 4px 20px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  background-color: white;
}

.search-trigger:focus {
  outline: none;
}

.search-trigger:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-text {
  font-size: 14px;
}
.shortcut-key {
  border: 1px solid rgba(0, 0, 0, 0.3);
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  background-color: rgba(0, 0, 0, 0.05);
  color: inherit;
}

@media (max-width: 600px) {
  .search-text,
  .shortcut-key {
    display: none;
  }

  .search-trigger {
    border: none;
    padding: 0;
    background-color: transparent;
  }

  .search-trigger .v-icon {
    margin-right: 0;
  }
  #zsiq_float {
  position: fixed !important;
  top: 100px !important;
  right: 30px !important;
  bottom: auto !important;
  left: auto !important;
  z-index: 9999 !important;
  transition: none !important;
}
}
</style>
